/*
=========================================================
* RingOperator How It Works — numbered timeline
=========================================================
*/

import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import { brandPrimary, brandCream, brandAccent } from "pages/RingOperatorHomepage/theme";

const line = "rgba(14,13,11,0.1)";
const muted = "rgba(14,13,11,0.55)";

const steps = [
  {
    k: "01",
    t: "Tell it about your business",
    d: "Paste your FAQ, hours, services, pricing. 5 minutes. No prompt engineering.",
    meta: "~5 min",
  },
  {
    k: "02",
    t: "Forward your number",
    d: "Keep the number you have. Forward on no-answer, after-hours, or 24/7. Your call.",
    meta: "~2 min",
  },
  {
    k: "03",
    t: "Go live",
    d: "First call comes in. Gets answered. Books on your calendar. You get the text.",
    meta: "< 30 min",
  },
];

function HowItWorks() {
  return (
    <MKBox component="section" id="how-it-works" className="ro-root" sx={{ py: { xs: 8, md: 12 }, background: brandCream }}>
      <Container>
        <Grid container alignItems="end" sx={{ mb: 6 }}>
          <Grid item xs={12} md={7}>
            <MKBox
              className="ro-mono"
              sx={{
                fontSize: 12,
                color: muted,
                textTransform: "uppercase",
                letterSpacing: "0.12em",
                mb: 2,
              }}
            >
              ◦ 30 minutes to live
            </MKBox>
            <MKTypography
              component="h2"
              sx={{
                m: 0,
                fontSize: { xs: "2.2rem", md: "4.5rem" },
                lineHeight: 0.95,
                letterSpacing: "-0.03em",
                fontWeight: 800,
                color: brandPrimary,
              }}
            >
              Three steps.{" "}
              <MKBox component="span" className="ro-serif" sx={{ fontStyle: "italic" }}>
                No phone tree.
              </MKBox>
            </MKTypography>
          </Grid>
        </Grid>

        <MKBox sx={{ borderTop: `1px solid ${line}` }}>
          {steps.map((s, i) => (
            <MKBox
              key={i}
              sx={{
                display: "grid",
                gridTemplateColumns: { xs: "60px 1fr", md: "120px 1.4fr 2fr 140px" },
                alignItems: "baseline",
                columnGap: { xs: 2, md: 4 },
                rowGap: 1,
                py: { xs: 3, md: 5 },
                borderBottom: `1px solid ${line}`,
                transition: "background 180ms ease",
                "&:hover": { background: "rgba(14,13,11,0.02)" },
              }}
            >
              <MKBox
                className="ro-mono"
                sx={{
                  fontSize: { xs: 20, md: 32 },
                  color: brandAccent,
                  fontWeight: 500,
                  alignSelf: "start",
                  mt: { md: 1 },
                }}
              >
                {s.k}
              </MKBox>
              <MKTypography
                component="h3"
                sx={{
                  m: 0,
                  fontSize: { xs: "1.4rem", md: "2rem" },
                  lineHeight: 1.05,
                  letterSpacing: "-0.02em",
                  fontWeight: 700,
                  color: brandPrimary,
                  gridColumn: { xs: "2 / 3", md: "auto" },
                }}
              >
                {s.t}
              </MKTypography>
              <MKTypography
                sx={{
                  color: muted,
                  fontSize: { xs: "0.95rem", md: "1.05rem" },
                  lineHeight: 1.55,
                  maxWidth: 520,
                  gridColumn: { xs: "2 / 3", md: "auto" },
                }}
              >
                {s.d}
              </MKTypography>
              <MKBox
                className="ro-mono"
                sx={{
                  fontSize: 12,
                  color: muted,
                  textTransform: "uppercase",
                  letterSpacing: "0.1em",
                  textAlign: { md: "right" },
                  gridColumn: { xs: "2 / 3", md: "auto" },
                }}
              >
                {s.meta}
              </MKBox>
            </MKBox>
          ))}
        </MKBox>
      </Container>
    </MKBox>
  );
}

export default HowItWorks;
